<span>
  <ng-container *ngIf="user; else empty">{{ user?.id }} {{ user?.surname }} {{ user?.name }}</ng-container>
  <ng-template #empty>{{ ifEmpty }}</ng-template>
</span>
